import React from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';

import dot from '../img/dote.png';

const Dots = ({ dotsArr }) => {
    const [dotImg] = useImage(dot);
    return (
        <>
            { dotsArr.map((dot, i) => <Image key={i} image={dotImg} width={dot.dotWidth} height={dot.dotHeight} x={dot.dotX} y={dot.dotY} />) }
        </>
    );
};

export default Dots;